import {
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Title,
  Tooltip
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { LabelOptions } from 'chartjs-plugin-datalabels/types/options'
import { Bar } from 'react-chartjs-2'

import { GymMode } from '@suntex.fim/enums'
import { GymGameNumber, gymOperandLabel } from '@suntex.fim/utils'

import { GymFacts } from '../../../pages/app/Module/gymsUtils'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

export const options: ChartOptions<any> = {
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: {
      color: 'black',
      formatter: (value: string) => {
        return `${value || 0}%\n` // patch:bottom margin not applicable so added with lines
      },
      font: {
        size: 14,
        weight: 700
      },
      anchor: 'end'
    } as LabelOptions,
    tooltip: {
      borderColor: '#D2D2D2',
      borderWidth: 1,
      displayColors: false,
      callbacks: {
        label: (context: any) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const label = context.raw || 0
          return ` ${label} %`
        },
        title: () => {
          return ''
        }
      },
      bodyAlign: 'center',
      backgroundColor: 'white',
      titleColor: 'black',
      bodyColor: 'black',
      bodyFont: {
        size: 14,
        weight: 700
      }
    }
  },
  maintainAspectRatio: true,
  layout: { autoPadding: true, padding: { top: 20 } },
  scales: {
    x: {
      ticks: {
        font: {
          size: 14,
          weight: 700
        }
      }
    },
    y: {
      min: 0,
      max: 100,
      // Show all major tick values
      major: {
        enabled: true
      },
      ticks: {
        stepSize: 20, // Adjust step size to ensure 10, 50, and 100 are displayed
        callback: (value: number | string) => `${value} %`
      }
    }
  },
  interaction: {
    intersect: false,
    mode: 'nearest',
    axis: 'x'
  }
}

/**
 * returns JSX for assessment skill set chart
 */
function GymCharts({
  backgroundColor,
  chartData = {},
  steps = 10,
  level
}: {
  backgroundColor: string
  chartData: GymFacts
  steps: number
  level: GymMode
}) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const labels = [...Array(steps)].map((_, i) => {
    const gameNumber = (i + 1) as GymGameNumber
    return gymOperandLabel(level, gameNumber)
  })
  const data: ChartData<'bar', number[], string> = {
    labels,
    datasets: [
      {
        data: labels.map((_label, i) => {
          return chartData[i + 1] || 0
        }),
        backgroundColor,
        borderRadius: 6,
        borderSkipped: false
      }
    ]
  }
  return (
    <div className="bar-chart-data">
      <Bar
        options={options as ChartOptions<'bar'>}
        data={data}
        className="chart-canvas"
      />
    </div>
  )
}

export default GymCharts
